import { useEffect, useState } from 'react'

function readLayoutVariant() {
  if (typeof document === 'undefined') {
    return {
      isMobileUI: false,
      isAdminAppUI: false,
      isDesktopUI: false,
    }
  }

  const classList = document.body.classList
  const isMobileUI = classList.contains('mobile-ui')
  const isAdminAppUI = classList.contains('admin-app-ui')
  const isDesktopUI = classList.contains('desktop-ui')

  return { isMobileUI, isAdminAppUI, isDesktopUI }
}

export function useLayoutVariant() {
  const [variant, setVariant] = useState(readLayoutVariant)

  useEffect(() => {
    const syncVariant = () => {
      setVariant(readLayoutVariant())
    }

    syncVariant()
    const observer = new MutationObserver(syncVariant)
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] })

    return () => observer.disconnect()
  }, [])

  return variant
}

